module.exports = __webpack_public_path__ + "img/q1_sp.8f18bd5d.svg";